/*
 * Title: Rewards/RedeemTab.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import RedeemTab component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import RedeemTab from "@containers/fans/Reward/RedeemTab";

type Props = {};

const RedeemTabPage = () => {
  const { redeemRewardActions } = require("@redux/RedeemRewardRedux");
  const dispatch = useDispatch();
  const creator = useSelector((state: any) => (state.creator));
  const programId = creator?.program?.id;

  useEffect(() => {
    const fetchRedeemRewardData = async () => {
      await redeemRewardActions.fetchRedeemRewards(dispatch, programId);
    };
    if (programId) {
      fetchRedeemRewardData();
    }
  }, [programId]);

  return <RedeemTab />;
};

export default RedeemTabPage;
